
import { Component, Vue, Prop } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";

import Avatar from "@/components/elements/Avatar.vue";

import AuthModule from "../../store/modules/auth";
import InboxModule from "../../store/modules/inbox";
import { itemSlug } from "../../model/inbox";

import { Review, ReviewStatus } from "../../../../shared/types";
import * as typeUtils from "../../../../shared/typeUtils";

@Component({
  components: {
    Avatar
  }
})
export default class InboxItem extends Vue {
  @Prop() public item!: Review;

  private authModule = getModule(AuthModule, this.$store);
  private inboxModule = getModule(InboxModule, this.$store);

  async mounted() {}

  public slugShort(item: Review) {
    return `${item.metadata.repo}#${item.metadata.number}`;
  }

  public slugLong(item: Review) {
    return itemSlug(item);
  }

  public statusClass(status: ReviewStatus) {
    return typeUtils.statusClass(status);
  }

  public statusIconName(status: ReviewStatus) {
    return typeUtils.statusIconName(status);
  }

  public formatTimestampLong(timestamp: number) {
    return typeUtils.formatTimestampLong(timestamp);
  }

  public formatTimestampShort(timestamp: number) {
    return typeUtils.formatTimestampShort(timestamp);
  }

  get needsAttention() {
    return this.assignedToMe && !this.isCompleted;
  }

  get isCompleted() {
    return this.item.state.closed;
  }

  get assignedToMe() {
    return typeUtils.isEffectivelyAssigned(
      this.item,
      this.authModule.assertUser.username,
      this.inboxModule.disableAutoAssignees(this.item)
    );
  }

  /**
   * The assignees shown to the user. In GitHub sync mode, "whose turn it
   * is" is derived from the actively-requested reviewers (falling back to
   * the author), not the raw assignees list.
   */
  get displayAssignees() {
    if (this.inboxModule.disableAutoAssignees(this.item)) {
      return typeUtils.calculateAssigneesForGithubSync(this.item);
    }

    return this.item.state.assignees;
  }
}
